import { render } from "./AppVideo.vue?vue&type=template&id=18d7a658"
import script from "./AppVideo.vue?vue&type=script&lang=js"
export * from "./AppVideo.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__